import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs';
import {API_PATH} from '../../shared/constants';
import {QuoteCategory} from '../models/quote.model';
import {FlowPageDataProduct, FlowSummary, QuoteCollation, QuoteCollationVap, QuotePageDataVaps} from '../../shared/models/quote.model';
import {GetPoliciesRequest} from '../../shared/models/get-policies-request.model';
import { UserStore } from '../../authentication/state/user.store';

const headers = new HttpHeaders()
  .set('content-type', 'application/json')
  .set('Access-Control-Allow-Origin', '*')
  .set('Accept', 'application/json');

@Injectable({
  providedIn: 'root'
})
export class QuotesService {
  public quoteCategories: QuoteCategory[] = [];

  constructor(
    private httpClient: HttpClient,
    private userStore: UserStore
  ) {
  }

  getQuotes(person_id: number, broker_id: number, product_type_id: number): Observable<any> {
    return this.httpClient.get(`${API_PATH.GET_QUOTES}/${person_id}/${broker_id}/${product_type_id}`, {headers, responseType: 'json'});
  }

  getQuotes2(request: GetPoliciesRequest): Observable<any> {
    const parameters = new Map<string, string>();
    parameters.set('person_id', request?.person_id?.toString());

    if (request?.product_type_id) {
      parameters.set('product_type_id', request?.product_type_id?.toString());
    }
    if (request?.broker_id) {
      parameters.set('broker_id', request?.broker_id?.toString());
    }
    if (request?.policy_id) {
      parameters.set('policy_id', request?.policy_id);
    }
    if (request?.page_size) {
      parameters.set('page_size', request?.page_size?.toString());
    }
    if (request?.page) {
      parameters.set('page', request?.page?.toString());
    }
    if (request?.brokerage_id) {
      parameters.set('brokerage_id', request?.brokerage_id?.toString());
    }
    if (request?.status) {
      parameters.set('status', request?.status);
    }
    if (request?.broker) {
      parameters.set('broker', request?.broker);
    }
    if (request?.product) {
      parameters.set('product', request?.product);
    }
    if (request?.search_query) {
      parameters.set('search_query', request?.search_query);
    }
    if (request?.sort_field) {
      parameters.set('sort_field', request?.sort_field);
    }
    if (request?.sort_order) {
      parameters.set('sort_order', request?.sort_order);
    }

    return this.runCommandNew('getQuotes2', parameters);
  }

  runCommandNew(command: string, parameters: Map<string, string>): Observable<any> {
    const parametersObject = {};
    for (const [key, value] of parameters) {
      parametersObject[key] = value;
    }

    const requestBody: any = {
      Parameters: parametersObject,
      Command: command
    };

    return this.httpClient.post(`${API_PATH.RUN_NEW_COMMAND}`, requestBody);
  }

  // getInsuranceProducts(): Observable<any> {
  //   return this.httpClient.post('https://uat.everything.insure/pages/quote.aspx/getProducts',
  //     {categoryid: 3, session_id: '1633352851386', flow_id: 1, groupid: 3, product_id: 0, collate: 1});
  // }

  // getPageData(page: string): Observable<string> {
  //   return this.httpClient.get<string>(`https://uat.everything.insure/api/?fn=getpagedata&category_id=${3}&session_id=${1633352851386}&group_id=${3}&page=${page}`, {responseType: 'text' as 'json'});
  // }

  // updateQuotePageCoverItems(productId: any): Observable<any> {
  //   return this.httpClient.post(`https://uat.everything.insure/api/?fn=updateproductselected&session_id=${1633352851386}&product_id=${productId}&group_id=${3}`, {}, {responseType: 'text' as 'json'});
  // }

  // getInsurers(productId: any): Observable<any> {
  //   return this.httpClient.get<string>(`https://uat.everything.insure/api/?fn=getclassitems&category_id=${3}&session_id=${1633352851386}&group_id=${3}&product_id=${productId}`, {responseType: 'text' as 'json'});
  // }

  // collateAddons(productId: any): Observable<any> {
  //   return this.httpClient.post('https://uat.everything.insure/pages/addons.aspx/collateAddons',
  //     {category_id: 3, session_id: '1632908783110', product_id: productId, group_id: 3});
  // }

  // getVapQuestions(vap_id: number, category_id: number): Observable<any>{
  //   return this.httpClient.post('https://uat.everything.insure/pages/addons.aspx/getVapQuestions',
  //   {session_id: '1632908783110', vap_id: vap_id, category_id: category_id});
  // }

  getWizardFlowQuestions(flowId, categoryId): void {
    this.httpClient.get(`${API_PATH.GET_FLOW_QUESTIONS}/${flowId}/${categoryId}`, {headers})
      .subscribe((flowQuestions: any) => {
        // console.log('flowQuestions: ', flowQuestions);
      });
  }

  getWizardQuoteLinks(): void {
    this.quoteCategories = [];
    const parameters = new Map<string, string>();
    let partner_code = this.userStore.getValue()?.partner_code;
    if (partner_code){
      parameters.set('partner_code', partner_code.toString());  
    }
    this.runCommandNew('getQuoteLinks', parameters).subscribe( categories => {
      this.quoteCategories = categories;
    }, err => {
      console.error('Failed to get Quote Categories.', err);
    })

    // this.httpClient.get(`${API_PATH.GET_QUOTE_LINKS}`, {headers})
    //   .subscribe((categories: QuoteCategory[]) => {
    //     this.quoteCategories = categories;
    //   }, err => {
    //     console.error('Failed to get Quote Categories.', err);
    //   });
  }

  getQuoteLinks(): Observable<QuoteCategory[]> {

    this.quoteCategories = [];
    const parameters = new Map<string, string>();
    let partner_code = this.userStore.getValue()?.partner_code;
    if (partner_code){
      parameters.set('partner_code', partner_code.toString());  
    }
    return this.runCommandNew('getQuoteLinks', parameters);

    //return this.httpClient.get<QuoteCategory[]>(`${API_PATH.GET_QUOTE_LINKS}`, {headers});
  }

  createQuote(new_session_id: string, category_id: number, product_group_id: number, user_id: number, curr_session_id: string, superflow_id: number): Observable<any> {
    return this.httpClient.get(`${API_PATH.CREATE_QUOTE}/${new_session_id}/${category_id}/${product_group_id}/${superflow_id}/${user_id}/${curr_session_id}`, {headers});
  }


  setupQuotePageSummary(product: FlowPageDataProduct, collations: QuoteCollation[], collationVaps: QuoteCollationVap[], frequency_id?: any): FlowSummary {
    const cartSummary = new FlowSummary();
    const classArray = [];
    cartSummary.product = product;
    if (!cartSummary.vaps) {
      cartSummary.vaps = {bundleValue: 0, items: ''};
    }
    const vapsArray = [];

    for (const c of collations) {
      if (c.class_id > 0 && !classArray.some(x => x.classId === c.class_id)) {
        classArray.push({classId: c.class_id, className: c.class_name});
      }
    }

    classArray.sort((a, b) => a.classId > b.classId ? 1 : a.classId < b.classId ? -1 : 0);

    for (const classItem of classArray) {
      if (this.getCount(classItem.classId, collations) > 0) {
        for (const c of collations) {
          if (c.class_id === classItem.classId && c.entry_type === 'item' && c.product_id === product.product_id && c.mandatory !== 1 && c.frequency_id === frequency_id && c.uw_result !== 3) {
            if (!cartSummary.classes?.length) {
              cartSummary.classes = [{classId: classItem.classId, className: classItem.className, showDropdown: c.open_shoppingcart === 1}];
            } else if (!cartSummary.classes.some(s => s.classId === classItem.classId)) {
              cartSummary.classes.push({classId: classItem.classId, className: classItem.className, showDropdown: c.open_shoppingcart === 1});
            }
          }

          if (c.product_id === product.product_id) {

            for (const v of collationVaps) {
              if (v.premium && v.product_id === product.product_id && v.product_vaps_rel === 'Optional' && v?.select === 1 && v.frequency_id === frequency_id) {
                if (!vapsArray.some(x => x === v.vaps_name)) {
                  vapsArray.push(v.vaps_name);
                  cartSummary.vaps.bundleValue += v.premium;
                }
                cartSummary.vaps.items = vapsArray?.length ? vapsArray.join('<br>') : 'No benefits included';
              }
            }
          }
        }

        for (const c of collations) {
          if (c.class_id === classItem.classId && c.entry_type === 'item' && c.product_id === product.product_id) {
            const discountList = c.discounts.split(',');
            for (const d of discountList) {
              const dl = d.split(':');
              if (dl[1]) {
                cartSummary.discounts?.length
                  ? cartSummary.discounts.push(dl[1])
                  : cartSummary.discounts = [dl[1]];
              }
            }

            const description = c.description_1?.split('|');
            if (c.mandatory === 1) {
              cartSummary.mandatory?.length
                ? cartSummary.mandatory.push({className: c.class_name, description: description[0], amount: c.prem_value})
                : cartSummary.mandatory = [{className: c.class_name, description: description[0], amount: c.prem_value}];
            }
            if (cartSummary.classes?.length) {
              cartSummary.classes.forEach(item => {
                if (item.classId === c.class_id && c.mandatory !== 1 && c.frequency_id === frequency_id) {
                  item.classItems?.length
                    ? item.classItems.push({description0: description?.length ? description[0] : '', description1: description?.length ? description[1] : '', amount: c.prem_value})
                    : item.classItems = [{description0: description?.length ? description[0] : '', description1: description?.length ? description[1] : '', amount: c.prem_value}];
                }
              });
            }
          }
        }
      }
    }
    cartSummary.taxes = {
      cartItem: this.getCartItem('taxes', cartSummary.product.product_id, collations),
      description: this.getCartDesc('taxes', cartSummary.product.product_id, collations)
    };
    cartSummary.serviceFee = {
      cartItem: this.getCartItem('fees', cartSummary.product.product_id, collations),
      description: this.getCartDesc('fees_subtotal', cartSummary.product.product_id, collations)
    };
    cartSummary.sasiria = {
      cartItem: this.getCartItem('sasria_subtotal', cartSummary.product.product_id, collations),
      description: 'SASRIA',
      popOver: 'Sasria is a short-term insurer that provides special risk cover that is not ' +
        'included in your standard insurance. This is unique cover against risks such as civil ' +
        'commotion, public disorder, strikes, riots and terrorism.'
    };
    return cartSummary;
  }

  setupCoverSummary(product: FlowPageDataProduct, collations: QuoteCollation[], collationVaps: QuoteCollationVap[]): FlowSummary {
    const cartSummary = new FlowSummary();
    const classArray = [];

    cartSummary.product = product;
    if (!cartSummary.vaps) {
      cartSummary.vaps = {bundleValue: 0, items: ''};
    }
    if (!cartSummary.addonVaps) {
      cartSummary.addonVaps = {bundleValue: 0, items: ''};
    }
    const vapsArray = [];
    const addonVapsArray = [];

    for (const c of collations) {
      if (c.class_id > 0 && !classArray.some(x => x.classId === c.class_id)) {
        classArray.push({classId: c.class_id, className: c.class_name});
      }

      if (c.product_id === product.product_id) {
        for (const v of collationVaps) {
          if (v.premium && v.product_id === product.product_id && v.product_vaps_rel === 'Bundle' && v.vaps_type_id === 1) {
            if (!vapsArray.some(x => x === v.vaps_name)) {
              vapsArray.push(v.vaps_name);
            }
            cartSummary.vaps.items = vapsArray?.length ? vapsArray.join('<br>') : 'No benefits included';
            cartSummary.vaps.bundleValue += v.premium;
          } else if (v.premium && v.product_id === product.product_id && v.product_vaps_rel === 'Optional' && c.entry_type === 'addon') {
            if (!addonVapsArray.some(x => x === v.vaps_name)) {
              addonVapsArray.push(v.vaps_name);
            }
          }
        }
      }
    }

    classArray.sort((a, b) => a.classId > b.classId ? 1 : a.classId < b.classId ? -1 : 0);

    for (const item of classArray) {
      if (this.getCount(item.classId, collations) > 0) {
        for (const c of collations) {
          if (c.class_id === item.classId && c.entry_type === 'item' && c.product_id === product.product_id && c.mandatory !== 1 && c.uw_result !== 3) {
            if (!cartSummary.classes?.length) {
              cartSummary.classes = [{classId: item.classId, className: item.className, showDropdown: c.open_shoppingcart === 1}];
            } else if (!cartSummary.classes.some(s => s.classId === item.classId)) {
              cartSummary.classes.push({classId: item.classId, className: item.className, showDropdown: c.open_shoppingcart === 1});
            }
            const discountList = c.discounts.split(',');
            for (const d of discountList) {
              const dl = d.split(':');
              if (dl[1]) {
                cartSummary.discounts?.length
                  ? cartSummary.discounts.push(dl[1])
                  : cartSummary.discounts = [dl[1]];
              }
            }

            const description = c.description_1.split('|');
            if (c.mandatory === 1) {
              cartSummary.mandatory?.length
                ? cartSummary.mandatory.push({className: c.class_name, description: description[0], amount: c.prem_value})
                : cartSummary.mandatory = [{className: c.class_name, description: description[0], amount: c.prem_value}];
            }
            if (cartSummary.classes?.length) {
              cartSummary.classes.forEach(x => {
                if (x.classId === c.class_id && c.mandatory !== 1) {
                  x.classItems?.length
                    ? x.classItems.push({description0: description[0], description1: description[1], amount: c.prem_value})
                    : x.classItems = [{description0: description[0], description1: description[1], amount: c.prem_value}];
                }
              });
            }
          }
        }
      }
    }
    if (this.getCartItem('addon_subtotal', product.product_id, collations) > 0) {
      cartSummary.addonVaps.items = addonVapsArray?.length ? addonVapsArray.join('<br>') : 'No benefits included';
      cartSummary.addonVaps.bundleValue = this.getCartItem('addon_subtotal', product.product_id, collations);
    }
    cartSummary.taxes = {
      cartItem: this.getCartItem('taxes', cartSummary.product.product_id, collations),
      description: this.getCartDesc('taxes', cartSummary.product.product_id, collations)
    };
    cartSummary.serviceFee = {
      cartItem: this.getCartItem('fees', cartSummary.product.product_id, collations),
      description: this.getCartDesc('fees_subtotal', cartSummary.product.product_id, collations)
    };
    cartSummary.sasiria = {
      cartItem: this.getCartItem('sasria_subtotal', cartSummary.product.product_id, collations),
      description: 'SASRIA',
      popOver: 'Sasria is a short-term insurer that provides special risk cover that is not ' +
        'included in your standard insurance. This is unique cover against risks such as civil ' +
        'commotion, public disorder, strikes, riots and terrorism.'
    };
    return cartSummary;
  }

  getIndexData(index: number, dataset: any[]): any[] {
    const data = [];
    for (const d of dataset) {
      if (d.index === index) {
        data.push(d);
      }
    }
    return data;
  }

  getVapPrice(v: QuotePageDataVaps, collations: QuoteCollation[]): string {
    let price = '';
    for (const c of collations) {
      if (v.product_vaps_id === c.vaps_id) {
        price = c.prem_value.toString();
      }
    }
    return price;
  }

  getCategory(category: any): string {
    switch (category.toString()) {
      case '1':
        return 'Business';
      case '2':
        return 'Professional';
      case '3':
        return 'Personal';
      case '4':
        return 'Funeral';
      case '5':
        return 'Tourism';
      default:
        return '';
    }
  }

  getCount(classId: number, collations: QuoteCollation[]): number {
    let x = 0;
    for (const c of collations) {
      if (c.class_id === classId && c.entry_type === 'item') {
        x++;
      }
    }
    return x;
  }

  getCartDesc(type: any, productId: any, collations: QuoteCollation[]): string {
    let a = '';
    for (const c of collations) {
      if (c.entry_type === type && c.product_id === productId) {
        a = c.description_1;
      }
    }
    return a;
  }

  getCartItem(type: any, classId: number, collations: QuoteCollation[]): number {
    let a = 0;
    switch (type) {
      case 'class':
        for (const c of collations) {
          if (c.class_id === classId && c.entry_type === 'class_discount') {
            a = c.prem_value;
          }
        }
        break;
      case 'multi':
        for (const c of collations) {
          if (c.class_id === classId && c.entry_type === 'multi_item_discount') {
            a = c.prem_value;
          }
        }
        break;
      case 'sasria':
        for (const c of collations) {
          if (c.entry_type === 'sasria_subtotal' && c.product_id === classId) {
            a = c.prem_value;
          }
        }
        break;
      case 'sasria_html':
        for (const c of collations) {
          if (c.entry_type === 'sasria_subtotal' && c.product_id === classId) {
            a = c.prem_value;
          }
        }
        break;
      case 'product_subtotal':
        for (const c of collations) {
          if (c.entry_type === 'product_subtotal' && c.product_id === classId) {
            a = c.prem_value;
          }
        }
        break;
      case 'product_total':
        for (const c of collations) {
          if (c.entry_type === 'product_total' && c.product_id === classId) {
            a = c.prem_value;
          }
        }
        break;
      case 'addon_count':
        for (const c of collations) {
          if (c.entry_type === 'addon') {
            a++;
          }
        }
        break;
      case 'insurer_rating':
        for (const c of collations) {
          if (c.entry_type === 'product_subtotal') {
            a = c.insurer_rating;
          }
        }
        break;
      default:
        for (const c of collations) {
          if (c.entry_type === type && c.product_id === classId) {
            a = c.prem_value;
          }
        }
        break;
    }
    return a;
  }

  checkAddFlag(v: QuotePageDataVaps, collationVaps: QuoteCollationVap[]): any {
    let flag = 0;
    for (const c of collationVaps) {
      if (v.product_vaps_id === c.product_vaps_id && c.product_vaps_rel === 'Optional') {
        flag = c.add_flag;
        return flag;
      }
    }
    return flag;
  }
}
